<header class="header">
  <span>{{titlePage}}</span>
  <span id="msp-icon" uiSvg source="assets/images/icon-myselogerpro"></span>
</header>
